// extracted by mini-css-extract-plugin
module.exports = {"textOuter":"Heading-module--textOuter--34Wr4","text":"Heading-module--text--2n137"};